import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SettingsEffects } from 'app/features/settings/state/settings/settings.effects';
import { settingsFeature } from 'app/features/settings/state/settings/settings.reducer';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(settingsFeature), EffectsModule.forFeature([SettingsEffects])],
})
export class SettingsStateModule {}
